/**
 * Root Component
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import IntlWrapper from './modules/Intl/IntlWrapper';
import { ConfigProvider } from 'react-avatar';

// Import Routes
import routes from './routes';

// Base stylesheet
require('./main.scss');

export default function App(props) {
  return (
    <Provider store={props.store}>
      <IntlWrapper>
        <ConfigProvider
          colors={[
            '#1AA3AD',
            '#0B73A8',
            '#F4742C',
            '#FF5C7B',
            '#B74179',
            '#49C8E0',
            '#235099',
            '#FEBF47',
            '#F35D9C',
            '#B20869',
            '#6B72B7',
            '#9398E6',
            '#9397DB',
            '#9DABC2',
            '#7085A3',
            '#90E0D1',
            '#F9535C',
            '#F28F57',
            '#E65f5A',
            '#2A95C4',
          ]}
        >
          <Router history={browserHistory}>{routes}</Router>
        </ConfigProvider>
      </IntlWrapper>
    </Provider>
  );
}

App.propTypes = {
  store: PropTypes.object.isRequired,
};
